import { QueryClient, MutationCache, QueryCache } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { processApiError } from '@/utils/errors';

const SILENT_STATUSES = new Set([401, 403, 404]);

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.meta?.suppressGlobalError) return;
      processApiError(error);
    },
  }),
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.options.meta?.suppressGlobalError) return;
      const status = (error as AxiosError)?.response?.status;
      if (status && SILENT_STATUSES.has(status)) return;
      processApiError(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      retry: (failureCount, error) => {
        const status = (error as AxiosError)?.response?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
  },
});
